import { FunctionComponent } from 'react';
import { oneLine } from 'common-tags';

import { TypePriceProps } from './types';
import { parsePrice } from '@/utils/utils';

export const Price: FunctionComponent<TypePriceProps> = ({
  className = '',
  regular,
  sale,
  position,
  size = 'small',
}: TypePriceProps) => {

  return (
    <div
      className={oneLine`
      inline-flex tracking-[0.04rem]
      ${position === 'below'
          ? 'flex-col'
          : 'flex-row-reverse gap-2 items-baseline'
        }
      ${className}
    `}
    >
      {sale && sale !== regular && (
        <p
          className={oneLine`
          text-secondary-600 line-through
          ${size === 'small'
              ? 'text-price text-price--s'
              : 'text-body text-body--m'
            }
        `}
        >
          {parsePrice(regular)}
        </p>
      )}

      <p
        className={oneLine`
        text-text-primary text-price
        ${size === 'small' ? 'text-price--m' : 'text-price--xl'}
        ${position === 'below' ? '' : 'md:text-price--l'}
      `}
      >
        {sale
          ? parsePrice(sale)
          : parsePrice(regular)}
      </p>
    </div>
  );
};

Price.displayName = 'Price';
